import { IconSource } from "../icon/icon.props";
import { PaginationEnums } from "../pagination";

export interface AtlCardBaseProps {
    internalId?: string | undefined;
    internalClassName?: string | undefined;
    cardTitle?: string | undefined;
    fixedSize?: boolean;
    cursorPointer?: boolean;
    hoverElevation?: boolean;
}

export interface AtlCardProps extends AtlCardBaseProps {
    cardDescription?: string | undefined;
}

export interface AtlAppCardProps extends AtlCardProps {
    bodyTextTitle?: string | undefined;
    cardTabIndex?: number;
    iconSource?: IconSource;
    iconName?: string;
}

export interface AtlContactCardProps extends AtlCardProps {
    initials: string;
    highlighted?: boolean;
    avatar?: string;
    avatarAlt?: string;
}

export interface AtlContactCardWithButtonProps extends AtlCardProps {
    initials: string;
    hasViewTeamCallback?: boolean;
    avatar?: string;
    avatarAlt?: string;
    contactName: string;
    contactPosition: string;
    contactMail: string
}

export interface AtlContactCardCarouselProps extends AtlContactCardWithButtonProps {
    carouselClassName?: string;
}

export interface AtlEventCardProps extends AtlCardProps {
    imageSrc: string;
    imageAlt?: string;
    bodyClassName?: string;
    showDateIcon?: boolean;
    date?: string;
    category?: string;
    categoriesPills?: string[];
    isHighLightCard?: boolean;
}

export interface AtlCardCarouselProps {
    pages: number;
    firstRenderActivePage: number;
    type: PaginationEnums.PaginationType
}

export interface AtlVideoCardProps {
    srcUrl?: string;
    videoTitle?: string;
    allowFullScreen?: boolean;
}

export enum AtlCardEvents {
    AppCardClick= 'onAppCardClick',
    CardClick = 'onCardClick',
    ContactCardButtonClick = 'atlantis-onViewTeamClick',
    ContactCardClick = 'onContactCardClick'
}

export const CardTags = {
    AppCard: 'atlantis-app-card',
    Card: 'atlantis-card',
    ContactCard: 'atlantis-contact-card',
    ContactCardWithButton: 'atlantis-contact-card-with-button',
    EventCard: 'atlantis-event-card',
    CardCarousel: 'atlantis-card-carousel',
    ContactCardCarousel: 'atlantis-contact-card-carousel',
    VideoCard: 'atlantis-video-card'
} as const;